import { parse } from 'qs';
import i18n from '@/i18n';

export type QueryParam = Record<string, string>;

export const getParseParam = <T extends QueryParam>(location: any, options?: Parameters<typeof parse>[1]): T =>
  parse(location?.search?.slice(1), options) as T;

export const acquireCluster = (): 'ttp' | 'row' => {
  const IDCMap: Record<string, 'row' | 'ttp'> = {
    ['eu-ttp']: 'row',
    sg: 'row',
    ['us-ttp']: 'ttp',
    va: 'row' // boe test region update
  };
  return IDCMap[window.__SELLER_APP_ENVS__?.idc.idc_name];
};
export const getSkipLink = (): string => {
  const online = 'moc.kotkit.su-relles//:sptth'.split('').reverse().join('');
  const boe = 'ten.ltnietyb.eob-relles//:sptth'.split('').reverse().join('');
  const isBoe = location.host.includes('boe');
  if (isBoe) {
    return boe;
  }
  return online;
};

// report
export const safeJSONStringify = (data: any): string => {
  try {
    return JSON.stringify(data);
  } catch (_error) {
    return '';
  }
};

export const safeJSONParse = (data: string): any => {
  try {
    return JSON.parse(data);
  } catch (_error) {
    return '';
  }
};

const FAQ_TOPIC_LANGUAGE_MAPPING: Record<string, string> = {
  'id-ID': 'id',
  'zh-CN': 'zh',
  'vi-VN': 'vi',
  'th-TH': 'th',
  'ms-MY': 'ms',
  'pt-BR': 'pt-BR',
  'ja-JP': 'ja-JP',
  'el-GR': 'el',
  'hu-HU': 'hu',
  'de-DE': 'de',
  fr: 'fr',
  pt: 'pt',
  'pl-PL': 'pl',
  'nl-NL': 'nl',
  'cs-CZ': 'cs'
};
export const getFaqTopicMappingLanguage = (): string => FAQ_TOPIC_LANGUAGE_MAPPING[i18n.language] ?? i18n.language;

export const isUSRegion = location.hostname.includes('seller-us.') || location.hostname.includes('seller.us.');
